import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";

const DateField = forwardRef((props, ref) => {
    const [hasError, setHasError] = useState(props.parentHasError);
    const [inputValue, setInputValue] = useState(props.value ? dayjs(props.value) : null);

    useEffect(() => {
        if (inputValue != "" && inputValue != undefined) {
            props.onChange(inputValue);
        }
    }, []);

    useImperativeHandle(ref, () => ({
        validate() {
            return isValidData();
        },
    }));

    const isValidData = () => {
        if (props.isRequired) {
            if (inputValue) {
                setHasError(false);
                return !false;
            } else {
                setHasError(true);
                return !true;
            }
        } else {
            setHasError(false);
            return !false;
        }
    };

    const validateInput = (event) => {
        console.log("Isrequired :: ", props.isRequired, "inputValue :: ", inputValue);
        if (props.isRequired) {
            if (inputValue) {
                setHasError(false);
                props.onChange(dayjs(inputValue.$d));
            } else {
                setHasError(true);
                props.onChange(null);
            }
        } else {
            setHasError(false);
        }
    };

    const removeValidate = (event) => {
        setHasError(false);
    };

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Typography variant="subtitle1" sx={{ color: "text.primary", mt: 1 }}>
                    {props.label}
                    {props.isRequired ? <span style={{ color: "#0080ff" }}>*</span> : ""}
                </Typography>
                <DatePicker
                    value={inputValue}
                    minDate={props.minDate ? props.minDate : ""}
                    onChange={(newValue) => {
                        setInputValue(newValue);
                        props.onChange(newValue);
                        props.isRequired ? (newValue > 0 ? setHasError(false) : setHasError(true)) : setHasError(false);
                    }}
                    onBlur={validateInput}
                    onFocus={removeValidate}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            error={hasError}
                            required={props.isRequired}
                            onBlur={validateInput}
                            onFocus={removeValidate}
                            inputProps={{
                                ...params.inputProps,
                                placeholder: props.placeholder,
                            }}
                            sx={{
                                m: 0,
                                py: 0.5,
                                input: {
                                    color: "#000",
                                    fontSize: "0.8rem",
                                    fontWeight: 400,
                                    "&::placeholder": {
                                        // <----- Add this.
                                        opacity: 1,
                                        color: "gray",
                                    },
                                },
                            }}
                            variant="outlined"
                        />
                    )}
                />
            </LocalizationProvider>
        </>
    );
});

export default DateField;
